import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const chatmonitoringService = {
    getActiveClasses,
    getActiveClassStudents,
    updateStudentBlocks,
    fetchFlaggedMessages,
    fetchReportedMessages,
    updateAwardCoins,
    getChatUsername,
    updateChatUsername,
    fetchAppConfigs
};

function getActiveClasses() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(api.chatmonitoring.fetchActiveClasses, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function getActiveClassStudents(classId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(`${api.chatmonitoring.getActiveStudents}/${classId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function updateStudentBlocks(blockData) {
    const requestOptions = {
        method: 'put',
        headers: authHeader()
    };

    return axiosInstance.put(api.chatmonitoring.updatestudentBlocks, blockData, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function fetchFlaggedMessages(classId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(`${api.chatmonitoring.fetchFlaggedMessages}/${classId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function fetchReportedMessages(classId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(`${api.chatmonitoring.fetchReportedMessages}/${classId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function updateAwardCoins(awardDetails) {
    const requestOptions = {
        method: 'post',
        headers: authHeader()
    };

    return axiosInstance.post(api.chatmonitoring.updateAwardCoins, awardDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function getChatUsername(classid, adminid) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    const url = `${api.chatmonitoring.getchatusername}?ClassID=${classid}&AdminUserID=${adminid}`;

    return axiosInstance.get(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}


function updateChatUsername(chatuserDetails) {
    const requestOptions = {
        method: 'post',
        headers: authHeader()
    };

    return axiosInstance.post(api.chatmonitoring.updateChatusername, chatuserDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function fetchAppConfigs() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(api.chatmonitoring.fetchAppconfigs, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}
